import React, { Component } from "react";
import RB_ProductPrint from "./RB_ProductPrint";

class RoomBookSection extends Component {
	state = {};
	render() {
		let { data } = this.props;

		return (
			<div className="RBuch-Area-Print">
				<span className="RBuch-AreaName-Print">{data.roomName}</span>
				<span className="RBuch-AreaSize-Print">
					{data.roomArea.toLocaleString("de-DE", {
						maximumFractionDigits: 2,
					})}{" "}
					m2
				</span>
				<div className="RBuch-AreaSum-Print">
					<span>{data.roomName} Summe</span>
					<span>
						{data.surcharge.toLocaleString("de-DE", {
							style: "currency",
							currency: "EUR",
							maximumFractionDigits: 2,
						})}
					</span>
				</div>
				{data.selectedChoice.map((materialData, id) => (
					<RB_ProductPrint key={id} data={materialData} />
				))}
			</div>
		);
	}
}

export default RoomBookSection;
